export const Stock_Column = {
  MAKE: 'merke',
  FARGE: 'farge',
  INTERIOR: 'interior',
  PRICE: 'pris',
  MODEL: 'modelDescription',
  BRUKSKODE: 'brukskode',
  REGNO: 'regNr',
  KMSTAND: 'kmStand',
  REGDATE: 'regDato',
  BRUKTIMPORT: 'bruktimport',
  FORHANDLER: 'forhandler',
  LAGERDAGER: 'lagerdager',
  EKSTRAUTSTYR: 'option',
  SERIALNO: 'serienummer',
  PROD_DATE: 'productionDate',
  CAMPAIGN: 'campaignExists',
  TTCode: 'trackTraceCode',
};
